import { render, staticRenderFns } from "./ContributorsPageCard.vue?vue&type=template&id=dc1f7a3a&"
import script from "./ContributorsPageCard.vue?vue&type=script&lang=js&"
export * from "./ContributorsPageCard.vue?vue&type=script&lang=js&"
import style0 from "./ContributorsPageCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContributorsPageCard.vue"
export default component.exports